import React, { useState, useContext, useEffect } from 'react';
import { RouteProps } from 'react-router-dom';
import UserContext from '../../context/user';
import Loading from '../../../shared/Loading';
import { LoginRedirectWithRouter } from '../LoginRedirectWithRouter';
import { NotFoundRoute } from '../NotFoundRoute';
import { AllowedRoleRoute } from './AllowedRoleRoute';
import { ORGANISATION_ROLES } from '../ClientRoute';
import * as E360 from '@expert360';
import * as PATHS from 'utils/constants/routes/paths';

export type Props = {
  // TODO: enum
  roles: string[];
  organisationRoles?: string[];
  redirect?: string;
  path?: string | string[];
} & RouteProps;

type State = {
  role: E360.UserRoleV2 | null;
  organisationRole: E360.OrganisationRole | null;
  loading: boolean;
  isUserAuthenticated: boolean;
};

const INITIAL_STATE: State = {
  role: null,
  organisationRole: null,
  loading: true,
  isUserAuthenticated: false,
};

const isIncludedInAllowedRoles = (roles: string[], userRole: string | null) =>
  !!userRole && roles.includes(userRole.toLowerCase());

// Only check if user org role if the user is a client
const isIncludedInAllowedOrganisationRoles = (
  role: string | null,
  organisationRoles: string[],
  organisationRole: string | null
) => {
  if (role == E360.UserRoleV2.Client) {
    return isIncludedInAllowedRoles(organisationRoles, organisationRole);
  } else {
    return true;
  }
};

const isExploreEnabledForClient = (user: any) => {
  return [E360.UserRoleV2.Admin, E360.UserRoleV2.Superadmin].includes(
    user?.role
  )
    ? true
    : [E360.UserRoleV2.Client].includes(user?.role)
    ? !!user?.client?.memberOf[0]?.hasExplore
    : false;
};

const isUserLocked = (user: any) => user?.locked;

export const RoleRoute: React.FC<Props> = ({
  roles,
  organisationRoles = ORGANISATION_ROLES,
  redirect,
  ...props
}) => {
  const [state, setState] = useState<State>(INITIAL_STATE);
  const user = useContext(UserContext);

  useEffect(() => {
    const role = user?.role ?? null;
    const organisationRole = user?.organisationRole ?? null;

    if (role === null) {
      setState({
        role: null,
        organisationRole: null,
        isUserAuthenticated: false,
        loading: false,
      });
    } else {
      setState({
        role,
        organisationRole,
        isUserAuthenticated: true,
        loading: false,
      });
    }
  }, []);

  return state.loading ? (
    <Loading />
  ) : state.isUserAuthenticated ? (
    user &&
    isIncludedInAllowedRoles(roles, state.role) &&
    isIncludedInAllowedOrganisationRoles(
      state.role,
      organisationRoles,
      state.organisationRole
    ) &&
    !isUserLocked(user) &&
    (props.path === PATHS.explore.index
      ? isExploreEnabledForClient(user)
      : true) ? (
      <AllowedRoleRoute user={user} {...props} />
    ) : (
      <NotFoundRoute {...props} />
    )
  ) : (
    <LoginRedirectWithRouter redirect={redirect} />
  );
};
